import { Form, Input } from "antd";
const SeoMetaForm = () => {
  return (
    <div className="py-5">
      {/* Links */}
      <Form.Item
        name="metaTitle"
        label="Meta Title"
        rules={[{ required: false, message: "This field is required" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="metaDescription"
        label="Meta Description"
        rules={[{ required: false, message: "This field is required" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="metaKeywords"
        label="Meta Keywords"
        rules={[{ required: false, message: "This field is required" }]}
      >
        <Input />
      </Form.Item>
    </div>
  );
};
export default SeoMetaForm;
